import script from "./MergeCardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MergeCardModal.vue?vue&type=script&setup=true&lang=js"

import "./MergeCardModal.vue?vue&type=style&index=0&id=1445006c&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1445006c"]])

export default __exports__